var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C4.14035 1 1 4.14035 1 8C1 11.8596 4.14035 15 8 15C11.8596 15 15 11.8596 15 8C15 4.14035 11.8596 1 8 1ZM11.9123 6.1579L7.4386 10.5965C7.17544 10.8596 6.75439 10.8772 6.47368 10.614L4.10526 8.45614C3.82456 8.19298 3.80702 7.75439 4.05263 7.47368C4.31579 7.19298 4.75439 7.17544 5.03509 7.4386L6.91228 9.1579L10.9123 5.1579C11.193 4.87719 11.6316 4.87719 11.9123 5.1579C12.193 5.4386 12.193 5.87719 11.9123 6.1579Z",
    fill: "#2EA8A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/Completed.aea0b6a06aabbeaa5a8a0010c4108685.svg";
export { ForwardRef as ReactComponent };